const localStorageNames = {
  SPLASH: 'splash',
  LOGO: 'logo',
  CREDENTIAL: 'creds',
  OUTLET: 'outlet_information',
  KIOSK: 'is_kiosk',
  USER: 'user_information',
  ORDERCATEGORY: 'order_category',
  TENANTS: 'list_tenant',
  PRODUCTS: 'list_product',
  CART_ITEMS: 'cart_items',
  THEME_COLOR: 'theme_color',
  SETTING: 'setting',
  FILLED_FEEDBACK: 'filled_feedback',
  TRANSACTIONS_ID: 'transactions_id',
  TENANT_ID: 'tenant_id',
  CATEGORIES: 'list_category',
  PRODUCTS_BY_CATEGORY: 'list_product_by_category',
  TOKEN: 'token',
  CLIENT_AMPLIFY: 'client_aws',
  MINIAPP_REQ: 'miniapp_req',
  MINIAPP_CONFIRM: 'miniapp_confirm',
};

export default localStorageNames;
